const f = (n) => {
  const { length: s } = n, e = {};
  if (s > 9) {
    const c = n.split(","), [l, a, r, i] = c;
    if (l.slice(0, 3) !== "rgb")
      throw new Error("Invalid color format");
    const g = l[3] === "a" ? l.slice(5) : l.slice(4), o = c.length;
    if (o < 3 || o > 4)
      return null;
    e.r = parseInt(g, 10), e.g = parseInt(a, 10), e.b = parseInt(r, 10), e.a = i ? parseFloat(i) : -1;
  } else {
    if (s === 8 || s === 6 || s < 4)
      throw new Error("Invalid hex color format");
    let c = n;
    if (s < 6 && (c = `#${n[1]}${n[1]}${n[2]}${n[2]}${n[3]}${n[3]}${s > 4 ? n[4] + n[4] : ""}`), s === 9 || s === 5) {
      const l = parseInt(c.slice(1, 3), 16);
      e.r = l;
      const a = parseInt(c.slice(3, 5), 16);
      e.g = a;
      const r = parseInt(c.slice(5, 7), 16);
      e.b = r;
      const i = parseInt(c.slice(7, 9), 16);
      e.a = Math.round(i / 255 * 100) / 100;
    } else {
      const l = parseInt(c.slice(1, 3), 16);
      e.r = l;
      const a = parseInt(c.slice(3, 5), 16);
      e.g = a;
      const r = parseInt(c.slice(5, 7), 16);
      e.b = r, e.a = -1;
    }
  }
  return e;
}, S = {
  r: 0,
  g: 0,
  b: 0,
  a: -1
}, R = {
  r: 255,
  g: 255,
  b: 255,
  a: -1
}, w = (n, s, { toColor: e, useLinear: c, reformat: l } = {}) => {
  const { round: a } = Math, r = Math.min(Math.max(n, -1), 1);
  (n < -1 || n > 1) && console.info(`Ratio should be between -1 and 1 and it is ${n}. It will be clamped to ${r}`);
  let i = s;
  s[0] !== "r" && s[0] !== "#" && (i = "#000", console.info(
    `Invalid input color format. "${s}" should be rgb(a) or hex. It will fallback to "${i}"`
  ));
  let g = i.length > 9 || i.includes("rgb(");
  if (g = l ? !g : g, e) {
    const u = e && (e == null ? void 0 : e.length) > 9 || (e == null ? void 0 : e.includes("rgb("));
    g = l ? !u : u;
  }
  const o = f(i), $ = r < 0 ? S : R, p = e && !l ? f(e) : $, h = Math.abs(r), b = 1 - h, t = {};
  c ? (t.r = a(b * o.r + h * p.r), t.g = a(b * o.g + h * p.g), t.b = a(b * o.b + h * p.b)) : (t.r = a((b * o.r ** 2 + h * p.r ** 2) ** 0.5), t.g = a((b * o.g ** 2 + h * p.g ** 2) ** 0.5), t.b = a((b * o.b ** 2 + h * p.b ** 2) ** 0.5));
  const I = o.a * b + p.a * h;
  t.a = p.a < 0 ? o.a : I;
  const d = o.a >= 0 || p.a >= 0;
  return g ? `rgb${d ? "a" : ""}(${t.r},${t.g},${t.b}${d ? `,${a(t.a * 1e3) / 1e3}` : ""})` : `#${(t.r * 16777216 + t.g * 65536 + t.b * 256 + (d ? a(t.a * 255) : 0)).toString(16).slice(0, d ? void 0 : -2)}`;
};
export {
  w as tint,
  f as toColorObject
};
//# sourceMappingURL=tint.js.map
